import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
    HOME_PATH,
    LOGIN_PATH,
    SIGNUP_PATH,
    OTP_PATH,
    VERIFICATION_PATH,
    FORGOT_PASSWORD_PATH,
    RESET_PASSWORD_PATH,
    NOT_FOUND_PATH,
    USER_ROLE_PATH,
    TOTP_PATH,
    INDIVIDUAL_USER_PATH,
    HOSPITAL_USER_PATH,
    NOTIFICATION_PATH,
    ONBOARDING_PATH,
    USER_DETAIL_PATH,
    HOSPITAL_DETAIL_PATH,
    CREATE_USER_PATH,
    CREATE_HOSPITAL_USER_PATH,
    UPDATE_USER_PATH,
    UPDATE_HOSPITAL_USER_PATH,
    PATIENT_PATH,
    DEVICE_PATH,
    NURSE_PATH,
    HOSPITAL_PATH,
    HELP_AND_SUPPORT_PATH,
    ANALYTICS_PATH,
    DEVICE_LIST_PATH,
    CREATE_NOTIFICATION_PATH,
    NOTIFICATION_INDIVIDUAL_PATH,
    CREATE_DEVICE_PATH,
    DEVICE_DETAIL_PATH,
    NURSE_DETAIL_PATH,
    DEVICE_LIST_DETAIL_PATH,
    UPDATE_NURSE_PATH,
    CREATE_NURSE_PATH,
    APPROVED_PATH,
    REVIEWED_PATH,
    NOT_APPROVED_PATH,
    REPORT_LIST_PATH,
    REPORT_PATH,
    DASHBOARD_PATH,
    ASSIGN_PATH,
    SETTING_PATH,
    PROFILE_PATH,
    HOSPITAL_DASHBOARD_PATH,
    CHANGE_PASSWORD_PATH,
    PROFILE_RESET_PASSWORD_PATH,
    NURSE_USER_PATH,
    ADMIN_NURSE_DETAIL_PATH,
    ADMIN_CREATE_NURSE_PATH,
    ASSIGN_LIST_PATH,
    MANAGEMENT_ASSIGN_PATH,
    CREATE_HOSPITAL_ADMIN_PATH,
    CREATE_HOSPITAL_ADMIN_PATH_2,
    UPDATE_HOSPITAL_ADMIN_PATH_2,
    ACTIVITY_LOG_PATH,
    ACTIVITY_LOG_DEVICE_PATH,
    AUDIT_LOG_PATH,
    INDIVIDUAL_DEVICE_PATH,
    INDIVIDUAL_CREATE_DEVICE_PATH,
    INDIVIDUAL_DEVICE_DETAIL_PATH,
    TERMS_AND_CONDITIONS_PATH,
    PRIVACY_POLICY_PATH,
} from '@constants/routes';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { Navigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import {
    setSessionStartTime,
    getSessionStartTime,
    isSessionExpired,
    clearSessionTime,
} from '@utils/authSession';
import {
    loginSuccess,
    logoutSuccess,
    setLoading,
    setLoggedInUserName,
    setLoggedInUserRole,
    setLoggedInUserTenantID,
    setLoggedInUserID,
    setLoggedInUserStatus,
    setLoggedInUserInfoUuid,
    setLoggedInUserEmail,
    setLoggedInUserMobileNumber,
    setLoggedInUserDeviceID,
    setLoggedInHospitalGstNo,
    setLoggedInHospitalBranch,
    setLoggedInHospitalName,
    setLoggedInUserAddressTwo,
    setLoggedInUserAddressOne,
    setLoggedInUserCity,
    setLoggedInUserCountry,
    setLoggedInUserState,
    setLoggedInUserPincode,
    setUserTableUuid,
    setHospitalTableUuid,
    setProfileImageName,
    setOldProfileImageName,
    setHospitalLogoUrl,
    setLoggedInHospitalWebSite,
    setLoggedInHospitalId,
    setLoggedInHospitalUuId,
    setLoggedInUserCognitoUuid,
    setProfileImageUrl,
    setLanguage,
} from '@store/reducers/auth/loginSlice';
// import NotFoundPage from '../components/NotFoundPage';

import About from '../views/pages/About/About';
import NotFoundPage from '@components/NotFoundPage';
import Home from '../views/pages/Home/Home';

import Login from '../views/pages/auth/login/Login';
import TOTP from '../views/pages/auth/login/Totp';
import ForgotPassword from '../views/pages/auth/login/ForgotPassword';
import ResetUserPassword from '../views/pages/auth/login/ResetPassword';
import UserRole from '../views/pages/auth/UserRole';
import Signup from '../views/pages/auth/signup/SignUp';
import OTP from '../views/pages/auth/Otp';
import Verification from '../views/pages/auth/Verification';
import OnboardingPage from '../views/pages/OnBoarding';
import {
    ADMIN,
    BLOCKED,
    EMAIL,
    HOSPITAL,
    INDIVIDUAL,
    NURSE,
} from '@constants/constants';
import { getUserAttributes, scan } from '@utils/authUtils';
import {
    TENANT_ID,
    USER_ROLE,
    COGNITO_USER_EMAIL,
    DEVICE_ID,
    USER_MOBILE_NUMBER,
    USER_NAME,
    COGNITO_USER_ID,
} from '@constants/cognitoAttributes';
import ApprovedPage from '@components/ApprovedPage';
import NotApprovedPage from '@components/NotApprovedpage';
import ReviewedPage from '@components/ReviewedPage';
import { fetchUserPermissions } from '@utils/fetchPermissions';
import { PermissionsProvider } from '../contexts/PermissionsContext';
import ProtectedComponent from '@components/ProtectedComponent';
import {
    ADMIN_ACTIVITY_LOG,
    AUDIT_LOG,
    CREATE_ADMIN_NOTIFICATION,
    CREATE_HOSPITAL_USER,
    CREATE_INDIVIDUAL_USER,
    CREATE_NURSE_USER,
    HOSPITAL_MANAGEMENT,
    READ_ADMIN_NOTIFICATION,
    READ_DEVICE,
    READ_HOSPITAL_USER,
    READ_INDIVIDUAL_USER,
    READ_NURSE_USER,
    UPDATE_HOSPITAL_USER,
    UPDATE_INDIVIDUAL_USER,
    UPDATE_NURSE_USER,
    VIEW_ADMIN_DASHBOARD,
    VIEW_HOSPITAL_DASHBOARD,
    VIEW_INDIVIDUAL_SIDEBAR,
    VIEW_NOTIFICATION,
} from '@constants/permissions';
import Loader from '@components/Loader';
import { HOSPITALS_TABLE, USER_INFO_TABLE } from '@constants/dynamoDBTableName';
import BlockedPage from '@components/BlockedPage';
import { hospitalInfoData, hospitalUserInfo } from '@utils/hospitalUtils';
import { handleFetchLogo, clearLocalStoragePreserveLanguage } from '@utils/utils';
import { getDataUsingTenantId, getDataUsingUserId } from '@utils/sharedUtils';
import HospitalBlockedPage from '@components/HospitalBlockedPage';
import { setAccessToken } from '@store/reducers/userSlice';
import PrivacyPolicy from '@components/PrivacyPolicy';
import TermsAndConditions from '@components/TermsAndConditions';
import { useTranslation } from 'react-i18next';
import HelpAndSupport from '@components/IndividualUser/HelpAndSupport';
import Swal from 'sweetalert2';

const AppRoutes = () => {
    const isAuthenticated = useAppSelector(
        (state) => state.login.isAuthenticated
    );
    const email = useAppSelector((state) => state.signup.email);
    const loginEmail = useAppSelector((state) => state.login.email);
    const loading = useAppSelector((state) => state.login.loading);
    const mfaPreferred = useAppSelector((state) => state.login.mfaPreferred);
    const signupUserRole = useAppSelector((state) => state.signup.userRole);
    const role = useAppSelector((state) => state.login.loggedInUserRole);
    const loggedInUserStatus = useAppSelector(
        (state) => state.login.loggedInUserStatus
    );
    const loggedInUserEmail = useAppSelector(
        (state) => state.login.loggedInUserEmail
    );
    const hospitalBlocked = useAppSelector(
        (state) => state.login.hospitalBlocked
    );
    const [userRole, setUserRole] = useState('');
    const [isFirstLogin, setFirstTimeLogin] = useState<boolean>(false);
    const { i18n } = useTranslation();

    const dispatch = useAppDispatch();

    const performAutoLogout = async (expiredNotification = true) => {
        try {
            await signOut();
        } catch (err) {
            console.error('Error during auto sign-out:', err);
        }
        clearLocalStoragePreserveLanguage();
        dispatch(logoutSuccess());
        if (expiredNotification) {
            Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: 'Session Expired',
                text: 'Your session has expired after 24 hours. Please log in again.',
                showConfirmButton: false,
                timer: 4000,
                toast: true,
                customClass: {
                    popup: '!text-amber-700 !bg-amber-50',
                },
            });
        }
    };

    async function currentAuthenticatedUser() {
        try {
            if (isSessionExpired()) {
                await performAutoLogout(true);
                return;
            }

            await getCurrentUser();
            const { accessToken, idToken } =
                (await fetchAuthSession()).tokens ?? {};

            if (accessToken && idToken) {
                dispatch(setAccessToken(accessToken.toString()));
                if (!getSessionStartTime()) {
                    setSessionStartTime();
                }
                await fetchAttributes();
            } else {
                clearLocalStoragePreserveLanguage();
                dispatch(logoutSuccess());
            }
        } catch (err) {
            // Check if it's a network/DNS error
            const isNetworkError =
                err &&
                ((err as any).name === 'NetworkError' ||
                 (err as any).message?.toLowerCase().includes('network error') ||
                 (err as any).message?.toLowerCase().includes('failed to fetch') ||
                 !navigator.onLine);

            if (isNetworkError) {
                console.warn('Network error during authentication verification. Retaining local session.', err);
                Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Network connection error. Retaining local session state.',
                    showConfirmButton: false,
                    timer: 4000,
                    toast: true,
                    customClass: {
                        popup: '!text-red !bg-light_red',
                    },
                });
            } else {
                // Suppress "UserUnAuthenticatedException" as it is expected for guest users
                if (err && (err as any).name !== 'UserUnAuthenticatedException') {
                    console.log(err);
                }
                // Ensure we treat this as a signed-out state
                clearLocalStoragePreserveLanguage();
                dispatch(logoutSuccess());
            }
        } finally {
            dispatch(setLoading(false));
        }
    }

    const fetchAttributes = async () => {
        try {
            const attributes = await getUserAttributes();
            if (typeof attributes !== 'string' && attributes !== null) {
                const role = attributes[USER_ROLE] ?? '';
                const emailId = attributes[COGNITO_USER_EMAIL] ?? '';
                const deviceId = attributes[DEVICE_ID] ?? '';
                const mobileNumber = attributes[USER_MOBILE_NUMBER] ?? '';
                const tenantId = attributes[TENANT_ID] ?? '';
                const cognitoUserId = attributes[COGNITO_USER_ID] ?? '';
                if (tenantId != '') {
                    // const res = await scan(USER_INFO_TABLE, tenantId);
                    if (role.toLowerCase() == HOSPITAL.toLowerCase()) {
                        const userInfo = await getDataUsingTenantId(
                            HOSPITALS_TABLE,
                            tenantId
                        );

                        if (
                            userInfo &&
                            userInfo.Items &&
                            userInfo.Items?.length != 0
                        ) {
                            const res = userInfo.Items[0];
                            const status = res.status?.S;
                            if (
                                status &&
                                status.toLowerCase() != 'approved' &&
                                status.toLowerCase() != 'verified'
                            ) {
                                clearLocalStoragePreserveLanguage();
                                dispatch(setLoggedInUserRole(role));
                                dispatch(setLoggedInUserStatus(status));
                                <Navigate to={HOME_PATH} />;
                                return;
                            }
                        }
                    }
                    const res = await getDataUsingUserId(
                        USER_INFO_TABLE,
                        cognitoUserId
                    );

                    if (res && res.Items && res?.Items.length != 0) {
                        const data = res.Items[0];
                        const name = data?.name?.S ?? '';
                        const address1 = data?.address1?.S ?? '';
                        const address2 = data?.address2?.S ?? '';
                        const state = data?.state?.S ?? '';
                        const city = data?.city?.S ?? '';
                        const country = data?.country?.S ?? '';
                        const pincode = data?.pincode?.S ?? '';
                        const uuid = data?.uuid?.S ?? '';
                        const language =
                            data?.language?.S || '';
                            if(language){
                                dispatch(setLanguage(language));
                                localStorage.setItem('appLanguage', language.toLowerCase());
                                i18n.changeLanguage(language);
                            } else {
                                // If no language in DB, use localStorage preference (e.g. set from onboarding)
                                const savedLang = localStorage.getItem('appLanguage');
                                if(savedLang){
                                    dispatch(setLanguage(savedLang));
                                    i18n.changeLanguage(savedLang);
                                }
                            }
                        const old_profile_image_name =
                            data?.profile_image_name?.S || '';
                        const profile_image_url = await handleFetchLogo(
                            data?.profile_image_name?.S || ''
                        );
                        const hos_id = data?.hospital_id?.S ?? '';
                        // const concatenatedAddress = `${address1} , ${address2},${city},${state},${country}`;
                        setUserRole(role);
                        setFirstTimeLogin(
                            data?.first_login?.BOOL
                                ? data?.first_login?.BOOL
                                : false
                        );
                        dispatch(setLoggedInUserRole(role));
                        dispatch(setLoggedInUserCognitoUuid(cognitoUserId));
                        dispatch(setLoggedInUserName(name));
                        dispatch(setLoggedInUserEmail(emailId));
                        dispatch(setLoggedInUserDeviceID(deviceId));
                        dispatch(setLoggedInUserMobileNumber(mobileNumber));
                        dispatch(setLoggedInUserAddressOne(address1));
                        dispatch(setLoggedInUserAddressTwo(address2));
                        dispatch(setLoggedInUserCity(city));
                        dispatch(setLoggedInUserCountry(country));
                        dispatch(setLoggedInUserState(state));
                        dispatch(setLoggedInUserPincode(pincode));
                        dispatch(setUserTableUuid(uuid));
                        if (old_profile_image_name !== undefined) {
                            dispatch(
                                setOldProfileImageName(old_profile_image_name)
                            );
                            dispatch(
                                setProfileImageName(old_profile_image_name)
                            );
                        } else {
                            dispatch(setOldProfileImageName(''));
                            dispatch(setProfileImageName(''));
                        }
                        if (profile_image_url !== undefined) {
                            dispatch(setProfileImageUrl(profile_image_url));
                        } else {
                            dispatch(setProfileImageUrl(''));
                        }
                        dispatch(
                            setLoggedInUserTenantID(
                                data?.tenant_id?.S ? data?.tenant_id?.S : ''
                            )
                        );
                        dispatch(
                            setLoggedInUserInfoUuid(
                                data?.uuid?.S ? data?.uuid?.S : ''
                            )
                        );
                        dispatch(
                            setLoggedInUserID(
                                data?.user_id?.S ? data?.user_id?.S : ''
                            )
                        );
                        dispatch(
                            setLoggedInUserStatus(
                                data?.status?.S ? data?.status?.S : ''
                            )
                        );
                        if (hos_id != '') {
                            dispatch(setLoggedInHospitalId(hos_id));
                        }
                        if (role.toLowerCase() == HOSPITAL.toLowerCase()) {
                            const resHospital =
                                await hospitalInfoData(tenantId);
                            if (resHospital && resHospital?.length != 0) {
                                const dataHospital = resHospital[0];
                                // console.log(dataHospital,'hospital Data')
                                const hospitaName =
                                    dataHospital?.hospital_name?.S ?? '';
                                const hospitaBranch =
                                    dataHospital?.hospital_branch?.S ?? '';
                                const hospitaLogo =
                                    dataHospital?.hospital_logo?.S ?? '';
                                const gstNo = dataHospital?.gst?.S ?? '';
                                const uuid = dataHospital?.uuid?.S ?? '';
                                const webSite =
                                    dataHospital?.hospital_website?.S ?? '';
                                const resHospitalInfo =
                                    await hospitalUserInfo(tenantId);

                                const hos_uuid = resHospitalInfo?.uuid ?? '';
                                if (hospitaLogo) {
                                    const hospitalLogoUrl =
                                        await handleFetchLogo(hospitaLogo);

                                    if (hospitalLogoUrl) {
                                        dispatch(
                                            setHospitalLogoUrl(hospitalLogoUrl)
                                        );
                                    }
                                }
                                dispatch(setLoggedInHospitalGstNo(gstNo));
                                dispatch(
                                    setLoggedInHospitalBranch(hospitaBranch)
                                );
                                dispatch(setLoggedInHospitalName(hospitaName));
                                dispatch(setHospitalTableUuid(uuid));
                                dispatch(setLoggedInHospitalWebSite(webSite));
                                dispatch(setLoggedInHospitalUuId(hos_uuid));
                            }
                        }

                        dispatch(loginSuccess());
                    }
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(setLoading(false));
        }
    };

    useEffect(() => {
        currentAuthenticatedUser();

        const intervalId = setInterval(() => {
            if (isAuthenticated && isSessionExpired()) {
                performAutoLogout(true);
            }
        }, 60000);

        const handleVisibilityOrFocus = () => {
            if (document.visibilityState === 'visible' && isAuthenticated && isSessionExpired()) {
                performAutoLogout(true);
            }
        };

        window.addEventListener('visibilitychange', handleVisibilityOrFocus);
        window.addEventListener('focus', handleVisibilityOrFocus);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('visibilitychange', handleVisibilityOrFocus);
            window.removeEventListener('focus', handleVisibilityOrFocus);
        };
    }, [isAuthenticated]);

    if (loading) {
        return <Loader />;
    }

    const renderHomePath = () => {
        if (userRole)
            switch (userRole.toLowerCase()) {
                case 'hospital':
                case 'nurse':
                    if (isFirstLogin) {
                        switch (loggedInUserStatus.toLowerCase()) {
                            case 'approved':
                                return <ApprovedPage />;
                            case 'waiting':
                                return <ReviewedPage />;
                            case 'rejected':
                                return <NotApprovedPage />;
                            case 'blocked':
                                if (hospitalBlocked) {
                                    return <HospitalBlockedPage />;
                                }
                                return <BlockedPage />;
                            default:
                                return userRole.toLowerCase() == 'hospital' ? (
                                    <Navigate to={HOSPITAL_DASHBOARD_PATH} />
                                ) : (
                                    <Navigate to={DEVICE_LIST_PATH} />
                                );
                        }
                    } else {
                        switch (loggedInUserStatus.toLowerCase()) {
                            case 'waiting':
                                return <ReviewedPage />;
                            case 'rejected':
                                return <NotApprovedPage />;
                            case 'blocked':
                                if (hospitalBlocked) {
                                    return <HospitalBlockedPage />;
                                }
                                return <BlockedPage />;
                            default:
                                return userRole.toLowerCase() == 'hospital' ? (
                                    <Navigate to={HOSPITAL_DASHBOARD_PATH} />
                                ) : (
                                    <Navigate to={DEVICE_LIST_PATH} />
                                );
                        }
                    }

                // return userRole.toLowerCase() == 'hospital' ? (
                //     <Navigate to={HOSPITAL_DASHBOARD_PATH} />
                // ) : (
                //     <Navigate to={DEVICE_LIST_PATH} />
                // );
                case 'individual':
                    if (
                        loggedInUserStatus.toLowerCase() ==
                        BLOCKED.toLowerCase()
                    ) {
                        return <BlockedPage />;
                    }
                    return <Navigate to={DEVICE_LIST_PATH} />;
                case 'super admin':
                    return <Navigate to={DASHBOARD_PATH} />;
                default:
                    return <Navigate to={ONBOARDING_PATH} />;
            }
        else {
            switch (loggedInUserStatus.toLowerCase()) {
                case 'waiting':
                    return <ReviewedPage />;
                case 'rejected':
                    return <NotApprovedPage />;
                case 'blocked':
                    if (hospitalBlocked) {
                        return <HospitalBlockedPage />;
                    }
                    return <BlockedPage />;
                default:
                    return <Navigate to={ONBOARDING_PATH} />;
            }
        }
    };

    const renderNotificationPath = () => {
        switch (userRole.toLowerCase()) {
            case 'hospital':
            case 'individual':
            case 'nurse':
                return <Home listType="notification_individual" />;
            case 'super admin':
                return <Home listType="notification" />;
            default:
                return <Navigate to={ONBOARDING_PATH} />;
        }
    };

    return (
        <PermissionsProvider>
            <Router>
                <Routes>
                    {/* <Route
                        path={HOME_PATH}
                        element={
                            isAuthenticated ? (
                                renderHomeComponent()
                            ) : (
                                <Navigate to={ONBOARDING_PATH} />
                            )
                        }
                    /> */}

                    <Route
                        path={HOME_PATH}
                        element={
                            isAuthenticated ? (
                                renderHomePath()
                            ) : (
                                <Navigate to={ONBOARDING_PATH} />
                            )
                        }
                    />

                    <Route
                        path={ONBOARDING_PATH}
                        element={
                            !isAuthenticated ? (
                                <OnboardingPage />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={LOGIN_PATH}
                        element={
                            !isAuthenticated ? (
                                <Login />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={TOTP_PATH}
                        element={
                            !isAuthenticated ? (
                                <TOTP />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    {/* <Route
                        path={USER_ROLE_PATH}
                        element={
                            !isAuthenticated ? (
                                <UserRole />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    /> */}
                    <Route
                        path={SIGNUP_PATH}
                        element={
                            !isAuthenticated ? (
                                signupUserRole != '' ? (
                                    <Signup />
                                ) : (
                                    <UserRole />
                                )
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={OTP_PATH}
                        element={email ? <OTP /> : <Navigate to={HOME_PATH} />}
                    />
                    <Route
                        path={VERIFICATION_PATH}
                        element={
                            email ? (
                                <Verification />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={FORGOT_PASSWORD_PATH}
                        element={
                            loginEmail || !isAuthenticated ? (
                                <ForgotPassword />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={RESET_PASSWORD_PATH}
                        element={
                            loginEmail ? (
                                <ResetUserPassword />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={INDIVIDUAL_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={READ_INDIVIDUAL_USER}
                                >
                                    <Home listType="individual" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={NURSE_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={READ_NURSE_USER}
                                >
                                    <Home listType="nurse" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={HOSPITAL_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={READ_HOSPITAL_USER}
                                >
                                    <Home listType="hospital" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />

                    <Route
                        path={NOTIFICATION_PATH}
                        element={
                            isAuthenticated ? (
                                renderNotificationPath()
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    {/* <Route
                        path={NOTIFICATION_PATH}
                        element={<Home listType="notification" />}
                    /> */}
                    {/* <Route
                        path={NOTIFICATION_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={VIEW_NOTIFICATION}
                            >
                                <Home listType="notification" />
                            </ProtectedComponent>
                        }
                    /> */}
                    <Route
                        path={USER_DETAIL_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="individualUserDetail" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />

                    <Route
                        path={HOSPITAL_DETAIL_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="hospitalUserDetail" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={ADMIN_NURSE_DETAIL_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="nurseUserDetail" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={CREATE_INDIVIDUAL_USER}
                                >
                                    <Home listType="createUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_HOSPITAL_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={CREATE_HOSPITAL_USER}
                                >
                                    <Home listType="createUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={UPDATE_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={UPDATE_INDIVIDUAL_USER}
                                >
                                    <Home listType="updateUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={UPDATE_HOSPITAL_USER_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={UPDATE_HOSPITAL_USER}
                                >
                                    <Home listType="updateUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_NOTIFICATION_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="createNotification" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    {/* <Route
                        path={CREATE_NOTIFICATION_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={CREATE_ADMIN_NOTIFICATION}
                            >
                                <Home listType="createNotification" />
                            </ProtectedComponent>
                        }
                    /> */}
                    <Route
                        path={DEVICE_LIST_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={READ_DEVICE}
                                >
                                    <Home listType="deviceList" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={ANALYTICS_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="analytics" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={HELP_AND_SUPPORT_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="helpAndSupport" />
                            ) : (
                                <HelpAndSupport />
                            )
                        }
                    />
                    <Route
                        path={AUDIT_LOG_PATH}
                        element={
                            <ProtectedComponent requiredPermission={AUDIT_LOG}>
                                <Home listType="auditLog" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={DEVICE_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="management/device" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={INDIVIDUAL_DEVICE_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={VIEW_INDIVIDUAL_SIDEBAR}
                            >
                                <Home listType="/device" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={PATIENT_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="management/patient" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={NURSE_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="managementNurse" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={UPDATE_NURSE_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={UPDATE_NURSE_USER}
                                >
                                    <Home listType="updateUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_NURSE_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={CREATE_NURSE_USER}
                                >
                                    <Home listType="createUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={ADMIN_CREATE_NURSE_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={CREATE_NURSE_USER}
                                >
                                    <Home listType="createUser" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={ACTIVITY_LOG_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={ADMIN_ACTIVITY_LOG}
                                >
                                    <Home listType="activityLog" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={NURSE_DETAIL_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="managementNurseDetail" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={HOSPITAL_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="management/hospital" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={NOTIFICATION_INDIVIDUAL_PATH}
                        element={
                            isAuthenticated ? (
                                renderNotificationPath()
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    {/* <Route
                        path={NOTIFICATION_INDIVIDUAL_PATH}
                        element={<Home listType="notification_individual" />}
                    /> */}
                    <Route
                        path={CREATE_HOSPITAL_ADMIN_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="createHospitalAdmin" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_HOSPITAL_ADMIN_PATH_2}
                        element={
                            isAuthenticated ? (
                                <Home listType="createHospitalAdmin" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={UPDATE_HOSPITAL_ADMIN_PATH_2}
                        element={
                            isAuthenticated ? (
                                <Home listType="updateHospitalAdmin" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={CREATE_DEVICE_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="managementDeviceCreateDevice" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={INDIVIDUAL_CREATE_DEVICE_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="individualCreateDevice" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={DEVICE_DETAIL_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="managementDeviceDetail" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={INDIVIDUAL_DEVICE_DETAIL_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="individualDeviceDetail" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={DEVICE_LIST_DETAIL_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="DeviceListDetail" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={APPROVED_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="approved" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={REVIEWED_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="reviewed" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={NOT_APPROVED_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="notApproved" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={REPORT_LIST_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="reportList" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={REPORT_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="report" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={SETTING_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="setting" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={PROFILE_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="profile" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={ASSIGN_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="assignDevice" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={MANAGEMENT_ASSIGN_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="assignDevice" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={ASSIGN_LIST_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={HOSPITAL_MANAGEMENT}
                            >
                                <Home listType="assignDeviceList" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={HOSPITAL_DASHBOARD_PATH}
                        element={
                            <ProtectedComponent
                                requiredPermission={VIEW_HOSPITAL_DASHBOARD}
                            >
                                <Home listType="hospital-dashboard" />
                            </ProtectedComponent>
                        }
                    />
                    <Route
                        path={CHANGE_PASSWORD_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="change-password" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={PROFILE_RESET_PASSWORD_PATH}
                        element={
                            isAuthenticated ? (
                                <Home listType="profile-reset-password" />
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route
                        path={DASHBOARD_PATH}
                        element={
                            isAuthenticated ? (
                                <ProtectedComponent
                                    requiredPermission={VIEW_ADMIN_DASHBOARD}
                                >
                                    <Home listType="admin-dashboard" />
                                </ProtectedComponent>
                            ) : (
                                <Navigate to={HOME_PATH} />
                            )
                        }
                    />
                    <Route path={NOT_FOUND_PATH} element={<NotFoundPage />} />
                    <Route path={TERMS_AND_CONDITIONS_PATH} element={<TermsAndConditions />} />
                    <Route path={PRIVACY_POLICY_PATH} element={<PrivacyPolicy />} />
                </Routes>
            </Router>
        </PermissionsProvider>
    );
};

export default AppRoutes;
